/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CreatePraticaFormDto } from '../models/create-pratica-form-dto';
import { PraticaCriteriaDto } from '../models/pratica-criteria-dto';
import { PraticaDto } from '../models/pratica-dto';
import { PraticaPageDto } from '../models/pratica-page-dto';
import { UpdatePraticaFormDto } from '../models/update-pratica-form-dto';


/**
 * Práticas
 */
@Injectable({
  providedIn: 'root',
})
export class PraticasService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getPraticas
   */
  static readonly GetPraticasPath = '/praticas';

  /**
   * Pesquisar práticas.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPraticas()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPraticas$Response(params?: {
    criteria?: PraticaCriteriaDto;
  }): Observable<StrictHttpResponse<PraticaPageDto>> {

    const rb = new RequestBuilder(this.rootUrl, PraticasService.GetPraticasPath, 'get');
    if (params) {
      rb.query('criteria', params.criteria, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PraticaPageDto>;
      })
    );
  }

  /**
   * Pesquisar práticas.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPraticas$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPraticas(params?: {
    criteria?: PraticaCriteriaDto;
  }): Observable<PraticaPageDto> {

    return this.getPraticas$Response(params).pipe(
      map((r: StrictHttpResponse<PraticaPageDto>) => r.body as PraticaPageDto)
    );
  }

  /**
   * Path part for operation createPratica
   */
  static readonly CreatePraticaPath = '/praticas';

  /**
   * Criar prática.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createPratica()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createPratica$Response(params?: {

    /**
     * apiRequest
     */
    body?: CreatePraticaFormDto
  }): Observable<StrictHttpResponse<PraticaDto>> {

    const rb = new RequestBuilder(this.rootUrl, PraticasService.CreatePraticaPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PraticaDto>;
      })
    );
  }

  /**
   * Criar prática.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createPratica$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createPratica(params?: {

    /**
     * apiRequest
     */
    body?: CreatePraticaFormDto
  }): Observable<PraticaDto> {

    return this.createPratica$Response(params).pipe(
      map((r: StrictHttpResponse<PraticaDto>) => r.body as PraticaDto)
    );
  }

  /**
   * Path part for operation getPratica
   */
  static readonly GetPraticaPath = '/praticas/{id}';

  /**
   * Obter prática.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPratica()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPratica$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<PraticaDto>> {

    const rb = new RequestBuilder(this.rootUrl, PraticasService.GetPraticaPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PraticaDto>;
      })
    );
  }

  /**
   * Obter prática.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPratica$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPratica(params: {
    id: number;
  }): Observable<PraticaDto> {

    return this.getPratica$Response(params).pipe(
      map((r: StrictHttpResponse<PraticaDto>) => r.body as PraticaDto)
    );
  }

  /**
   * Path part for operation updatePratica
   */
  static readonly UpdatePraticaPath = '/praticas/{id}';

  /**
   * Atualizar prática.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updatePratica()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePratica$Response(params: {
    id: number;
    body?: UpdatePraticaFormDto
  }): Observable<StrictHttpResponse<PraticaDto>> {

    const rb = new RequestBuilder(this.rootUrl, PraticasService.UpdatePraticaPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PraticaDto>;
      })
    );
  }

  /**
   * Atualizar prática.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updatePratica$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePratica(params: {
    id: number;
    body?: UpdatePraticaFormDto
  }): Observable<PraticaDto> {

    return this.updatePratica$Response(params).pipe(
      map((r: StrictHttpResponse<PraticaDto>) => r.body as PraticaDto)
    );
  }

  /**
   * Path part for operation ativarPratica
   */
  static readonly AtivarPraticaPath = '/praticas/{id}/ativar';

  /**
   * Ativar pratica.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ativarPratica()` instead.
   *
   * This method doesn't expect any request body.
   */
  ativarPratica$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<PraticaDto>> {

    const rb = new RequestBuilder(this.rootUrl, PraticasService.AtivarPraticaPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PraticaDto>;
      })
    );
  }

  /**
   * Ativar pratica.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `ativarPratica$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ativarPratica(params: {
    id: number;
  }): Observable<PraticaDto> {

    return this.ativarPratica$Response(params).pipe(
      map((r: StrictHttpResponse<PraticaDto>) => r.body as PraticaDto)
    );
  }

  /**
   * Path part for operation desativarPratica
   */
  static readonly DesativarPraticaPath = '/praticas/{id}/desativar';

  /**
   * Desativar pratica.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `desativarPratica()` instead.
   *
   * This method doesn't expect any request body.
   */
  desativarPratica$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<PraticaDto>> {

    const rb = new RequestBuilder(this.rootUrl, PraticasService.DesativarPraticaPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PraticaDto>;
      })
    );
  }

  /**
   * Desativar pratica.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `desativarPratica$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  desativarPratica(params: {
    id: number;
  }): Observable<PraticaDto> {

    return this.desativarPratica$Response(params).pipe(
      map((r: StrictHttpResponse<PraticaDto>) => r.body as PraticaDto)
    );
  }

}
